module.exports = __webpack_public_path__ + "static/media/la-picture-1.1f0f0e8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/la-picture-1.jpg
// module id = 569
// module chunks = 0